import React from "react";

const ArrowLeftIcon = () => {
  return <span className="icon-arrow_left" />;
};

export default ArrowLeftIcon;
